import { useEffect, useState, useRef, useMemo } from "react";
import api from "../../../../services/api";
import apiPublic from "../../../../services/apiPublic";
import { EasyMapsResponse } from "../../../../schemas/onus";
import {
  Stack,
  Snackbar,
  Alert,
  CircularProgress,
  Box,
  Typography,
  useTheme,
  useMediaQuery,
} from "@mui/material";
import { useOutletContext, useParams } from "react-router-dom";
import "../../../../componentes/leaflet-migrations";
import "../../../../componentes/leaflet-fullscreen/Leaflet.fullscreen";
import { useNavigate } from "react-router-dom";
import LoadingUpdate from "../../../../componentes/easyMaps/loadingUpdate";
import LeafletMap from "./leaflatMapa/index";
import SliderBarMapsOnus from "../../../../componentes/easyMaps/sideBarEasyMapsOnus";
import getCentroid from "../utils/getCentroid";
import { MapaContext } from "../../../../contexts/mapaContext";

export default function MapaGeolocalizadoONUs({
  socketCliente,
  isPublic = false,
}) {
  const tipo = "easymon";
  const mapRef = useRef();
  const theme = useTheme();
  const navigate = useNavigate();
  const [snackbar, setSnackbar] = useState(null);
  const [produtos, setProdutos] = useState(false);
  const [map, setMap] = useState(null);
  const [invalidElements, setInvalidElements] = useState([]);

  const [ctosMap, letCtosMap] = useState(new Map());
  const [onusMap, letOnusMap] = useState(new Map());
  const [ctosInvalidMap, setCtosInvalidMap] = useState(new Map());
  const [onusInvalidMap, setOnusInvalidMap] = useState(new Map());

  const [elements, setElements] = useState([]);
  const [elementSelected, setElementSelected] = useState(null);
  const [elementONUSelected, setElementONUSelected] = useState(null);
  const [dataONUS, setDataONUS] = useState(null);
  const [connectionSelected, setConnectionSelected] = useState(null);
  const [connections, setConnections] = useState([]);
  const [fullScreem, setFullScreem] = useState(false);
  const [mapas, setMapas] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [iconsElements, setIconsElements] = useState([]);
  const [loadingMap, setLoadingMap] = useState(true);
  const [loadingDetails, setLoadingDetails] = useState(false);
  const [checkChanges, setCheckChanges] = useState(false);
  const [isDateRecent, setIsDateRecent] = useState(true);
  const [sinc, setSinc] = useState(false);
  const sincRef = useRef(false);
  const [collapse, setCollapse] = useState(false);
  const [configurationMap, setConfigurationMap] = useState(null);
  const [cities, setCities] = useState({});
  const isSmall = useMediaQuery(theme.breakpoints.down("md"));
  const { config, configLayer, setConfigLayer } = useOutletContext();
  const [citiesFilter, setCitiesFilter] = useState([]);
  const currentSerialRef = useRef(null);

  const latLngZoomFromUrl = useMemo(() => {
    const url = new URL(window.location.href);
    const lat = url.searchParams.get("lat");
    const lng = url.searchParams.get("lng");
    const zoom = url.searchParams.get("zoom");
    return { lat, lng, zoom };
  }, []);

  const isMobile =
    navigator.userAgentData?.mobile === true ||
    window.matchMedia("(pointer: coarse)").matches;

  const allElementsMap = useMemo(() => {
    return new Map([
      ...onusMap,
      ...ctosMap,
      ...ctosInvalidMap,
      ...onusInvalidMap,
    ]);
  }, [onusMap, ctosMap, ctosInvalidMap, onusInvalidMap]);

  useEffect(() => {
    setCollapse(isSmall);
  }, [isSmall]);

  useEffect(() => {
    if (config) {
      handleApiGetElements();
    }
  }, [config]);

  useEffect(() => {
    if (!config) return;
    const link = config?.configuracoes?.ftth?.linkFTTH;
    if (link == null || link == undefined || link == "") {
      navigate("/easyMaps");
    }
  }, [config?.configuracoes?.ftth?.linkFTTH]);

  useEffect(() => {
    if (!map || !config) return;
    if (!configurationMap) {
      setConfigurationMap({
        configuracoes: {
          animacao: config?.configuracoes?.ftth?.animacao,
          camadaFTTH: {
            filtros: config?.configuracoes?.ftth?.camadaFTTH?.filtros,
          },
          esconderOnu: config?.configuracoes?.ftth?.esconderOnu,
          showOnusWithoutCto: config?.configuracoes?.ftth?.showOnusWithoutCto,
        },
      });
    }
  }, [map, config]);

  const { groupMapsId, id } = useParams();
  const handleCollapse = () => {
    setCollapse(!collapse);
  };
  const handleFullscreen = (value) => {
    setFullScreem(value);
    if (!isMobile) setCollapse(value);
  };
  const styles = {
    fullScreem: {
      position: "fixed",
      zIndex: 1500,
      width: "100dvw",
      height: "100dvh",
      left: 0,
      top: 0,
      backgroundColor: theme.palette.background.default,
    },
    noFullScreem: {
      position: "relative",
      ml: { xs: "0px", md: collapse ? "0px" : "340px" },
      width: {
        xs: "100dvw",
        md: "calc(100dvw - " + (collapse ? "0px" : "340px") + ")",
      },
      height: { xs: "calc(100dvh - 60px)", sm: "calc(100dvh - 67px)" },
    },
    loadingMap: {
      position: "absolute",
      zIndex: 1000,
      width: "100%",
      height: "100%",
      backgroundColor: theme.palette.mode != "dark" ? "#e0e0e093" : "#00000093",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: "column",
      gap: 4,
    },
  };

  useEffect(() => {
    if (elementSelected == null || editMode == true) return;
    const isCto = elementSelected?.tipoElemento === "cto";
    setElementSelected(() =>
      isCto ? ctosMap.get(elementSelected.id) : onusMap.get(elementSelected.id),
    );
  }, [ctosMap, onusMap]);

  useEffect(() => {
    if (connectionSelected == null || checkChanges) return;

    // setConnectionSelected({
    //   ...connections.find((conn) => conn.id == connectionSelected.id),
    // });
    setConnectionSelected(connections.get(connectionSelected.id));
  }, [connections]);

  useEffect(() => {
    async function fetchData() {
      setLoadingMap(true);
      await handleApiGetMap(id);
      setLoadingMap(false);
      setLoadingDetails(true);
      getIconDB();
    }
    fetchData();
  }, [id]);

  useEffect(() => {
    if (!map) return;
    async function fetchData() {
      await handleApiGetElements();
      setLoadingDetails(false);
    }
    fetchData();
  }, [map]);

  useEffect(() => {
    if (!configLayer?.[id]) {
      setConfigLayer((configLayer) => ({
        ...configLayer,
        [id]: "ftth",
      }));
    }
    let timeInterval = config?.configuracoes?.ftth?.atualizacao || 5 * 60000;

    let interval = setInterval(() => {
      handleApiGetElements();
    }, timeInterval);

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [id, config]);

  const getSerial = (id) => (id ?? "").replace(/_onu$/i, "").trim();

  useEffect(() => {
    const id = elementONUSelected?.id;
    const linkId = elementONUSelected?.linkId;

    if (!id) return;

    const serial = getSerial(id).toUpperCase();
    currentSerialRef.current = serial;

    setDataONUS(null);

    const ctrl = new AbortController();

    (async () => {
      try {
        const resp = await api.post(
          `/easyMaps/${map?.tipo == 3 ? "onus" : "ping"}/find`,
          { onuId: serial, linkId: linkId },
          { signal: ctrl.signal },
        );

        const payload = resp?.data;
        if (!payload) {
          setDataONUS({});
          return;
        }

        if (map?.tipo == 3) {
          const arr = Array.isArray(payload) ? payload : [payload];

          const match = arr.find(
            (o) =>
              (o?.serialOnu ?? o?.serialONu ?? "").trim().toUpperCase() ===
              serial,
          );

          if (currentSerialRef.current !== serial) return;

          setDataONUS(match);
        } else {
          setDataONUS(payload);
        }
      } catch (error) {
        const aborted =
          error?.name === "AbortError" ||
          error?.name === "CanceledError" ||
          error?.code === "ERR_CANCELED" ||
          ctrl.signal.aborted;

        if (aborted) return;

        console.error(error);
        setSnackbar?.({
          children: `Error: ${
            error?.response?.data?.error ||
            "Não foi possível buscar dados da ONU"
          }`,
          severity: "error",
        });
      }
    })();

    return () => {
      ctrl.abort();
    };
  }, [elementONUSelected?.id]);

  async function handleApiGetMap(id) {
    try {
      let response;
      if (isPublic) {
        response = await apiPublic.post("/easyMaps/public/map/findMapById", {
          mapId: id,
        });
      } else {
        response = await api.post("/easyMaps/map/findMapById", {
          mapId: id,
        });
      }

      if (response.data.status === "Error") {
        setSnackbar({
          children: " Não foi possível buscar o mapa",
          severity: "error",
        });
      } else {
        if (response.data.tipo != 3 && response.data.tipo != 4)
          navigate("/easyMaps");
        else {
          const { ConfigMapEasyMaps, ...map } = response.data;
          setMap(map);
          setConfigurationMap(ConfigMapEasyMaps);
        }
      }
    } catch (error) {
      console.error(error);
      if (error?.response?.status == 404) navigate("/easyMaps/notFound");
      setSnackbar({
        children: `Error:${
          error?.message || "Error: Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }

  async function handleApiGetElements() {
    if (!map || sincRef.current) return;
    setSinc(true);
    sincRef.current = true;
    try {
      //setLoadingProdutos(true);
      let response, buffer;

      if (isPublic) {
        buffer = await apiPublic.post(
          `/easyMaps/public/${map?.tipo == 3 ? "onus" : "ping"}/findMany`,
          {
            mapId: id,
          },
          { responseType: "arraybuffer" },
        );
      } else {
        buffer = await api.post(
          `/easyMaps/${map?.tipo == 3 ? "onus" : "ping"}/findMany`,
          {
            mapId: id,
          },
          { responseType: "arraybuffer" },
        );
      }

      if (buffer?.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível carregar os mapas",
          severity: "error",
        });
      } else {
        const message = EasyMapsResponse.decode(new Uint8Array(buffer.data));
        response = EasyMapsResponse.toObject(message, {
          enums: String,
          longs: Number,
          defaults: true,
        });
        if (response) {
          let OnusMap = new Map();
          let CtosMap = new Map();
          let ConnectionsMap = new Map();
          let OnusInvalidMap = new Map();
          let CtosInvalidMap = new Map();

          response.elements.forEach((el) => {
            if (el.tipoElemento === "onu") {
              OnusMap.set(el.id, el);
            } else if (el.tipoElemento === "cto") {
              CtosMap.set(el.id, el);
            } else {
              console.log("element with unknown type", el);
            }
          });

          response.connections.forEach((conn) => {
            ConnectionsMap.set(conn.id, conn);
          });

          response.invalidElements.forEach((invEl) => {
            if (invEl.tipoElemento === "onu") {
              OnusInvalidMap.set(invEl.id, invEl);
            } else if (invEl.tipoElemento === "cto") {
              CtosInvalidMap.set(invEl.id, invEl);
            } else {
              console.log("invalid element with unknown type", invEl);
            }
          });

          letCtosMap(CtosMap);
          letOnusMap(OnusMap);
          setCtosInvalidMap(CtosInvalidMap);
          setOnusInvalidMap(OnusInvalidMap);

          setCities(response?.cities || {});
          //setElements(ElementsMap);
          setConnections(ConnectionsMap);
          //setInvalidElements(invalidElementsMap);
          setIsDateRecent(response?.isDateRecent);
          if (response?.warningUrls && response?.warningUrls?.length !== 0) {
            setSnackbar({
              children: `Warning: A(s) URL(s): ${response?.warningUrls.join()} falharam ao buscar os dados`,
              severity: "warning",
            });
          }
        }
      }
    } catch (error) {
      console.log(error);
      setSnackbar({
        children: `Error: ${
          error?.response?.data?.error ||
          "Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    } finally {
      setSinc(false);
      sincRef.current = false;
    }
  }

  async function getIconDB() {
    try {
      let response;
      if (isPublic) {
        response = await apiPublic.get("/easyMaps/public/img/findMany");
      } else {
        response = await api.get("/easyMaps/img/findMany");
      }

      if (response.data.status === "Error") {
        setSnackbar({
          children: "Error: Não foi possível buscar os icons",
          severity: "error",
        });
      } else {
        setIconsElements(response.data);
      }
    } catch (error) {
      console.error(error);
      setSnackbar({
        children: `Error:${
          error?.message || "Error: Não foi possível se conectar com o servidor"
        } `,
        severity: "error",
      });
    }
  }
  function isValidCoord(c) {
    const lat = Number(c.lat);
    const long = Number(c.long);
    return (
      c &&
      !isNaN(lat) &&
      !isNaN(long) &&
      lat >= -90 &&
      lat <= 90 &&
      long >= -180 &&
      long <= 180
    );
  }

  const coordinates = [...elements.values()]
    .map((el) => el.coordenadas)
    .filter(isValidCoord);

  const boundsCoordinates = useMemo(() => {
    if (coordinates.length > 0) {
      return coordinates.map((c) => [Number(c.lat), Number(c.long)]);
    }
    return null;
  }, [coordinates]);

  const centerCoordinates = useMemo(() => {
    if (latLngZoomFromUrl.lat && latLngZoomFromUrl.lng)
      return [Number(latLngZoomFromUrl.lat), Number(latLngZoomFromUrl.lng)];
    const res = getCentroid(coordinates);
    if (
      res &&
      typeof res.lat === "number" &&
      typeof res.long === "number" &&
      !isNaN(res.lat) &&
      !isNaN(res.long)
    ) {
      return [res.lat, res.long];
    }
    return [-10, -48];
  }, [coordinates]);

  return (
    <MapaContext.Provider
      value={{
        mapId: id,
        tipo: "ftth",
        configurationMap,
        setConfigurationMap,
        setSnackbar,
        snackbar,
        isPublic,
        cities,
        citiesFilter,
        setCitiesFilter,
        ctosInvalidMap,
        onusInvalidMap,
        ctosMap,
        onusMap,
        allElementsMap,
        connections,
        loadingDetails,
        setLoadingDetails,
        mapType: map?.tipo,
        dataONUS,
        iconsElements,
        elementSelected,
      }}
    >
      <Stack direction="row">
        {!fullScreem && (
          <SliderBarMapsOnus
            map={map}
            iconsElements={iconsElements}
            mapRef={mapRef}
            configLocal={configurationMap?.configuracoes?.ftth}
            config={config}
            collapse={collapse}
            handleCollapse={handleCollapse}
          />
        )}
        <Stack sx={!fullScreem ? styles.noFullScreem : styles.fullScreem}>
          {(loadingMap || loadingDetails) && (
            <Box sx={styles.loadingMap}>
              <CircularProgress size="50px" disableShrink />
              <Typography
                fontSize="14px"
                color={theme.palette.color.textEasyMaps}
              >
                {loadingDetails
                  ? "Estamos ajustando os últimos detalhes…"
                  : "Só um momento, carregando os dados do mapa…"}
              </Typography>
            </Box>
          )}

          <LoadingUpdate
            visible={sinc && !(loadingMap || loadingDetails)}
            elementSelected={!!elementSelected}
            rulerMode={isSmall && citiesFilter.length > 0}
          />
          <LeafletMap
            setFullScreem={handleFullscreen}
            fullScreem={fullScreem}
            socketCliente={socketCliente}
            ref={mapRef}
            elements={elements}
            invalidElements={invalidElements}
            connections={JSON.parse(
              JSON.stringify(connections ? connections : []),
            )}
            setElementSelected={setElementSelected}
            setElementONUSelected={setElementONUSelected}
            connectionSelected={connectionSelected}
            setConnectionSelected={setConnectionSelected}
            elementSelected={elementSelected}
            elementONUSelected={elementONUSelected}
            iconsElements={iconsElements}
            setIconsElement={setIconsElements}
            mapId={id}
            title={map?.titulo}
            element={editMode ? elementSelected : null}
            setElements={setElements}
            setConnections={setConnections}
            produtos={produtos}
            api={api}
            setSnackbar={setSnackbar}
            mapas={mapas}
            setMapas={setMapas}
            editMode={editMode}
            setEditMode={setEditMode}
            checkChanges={checkChanges}
            setCheckChanges={setCheckChanges}
            dataONUS={dataONUS}
            centerCoordinates={centerCoordinates}
            boundsCoordinates={boundsCoordinates}
            initialZoom={latLngZoomFromUrl.zoom}
            isDateRecent={isDateRecent}
            collapse={collapse}
          />
        </Stack>
      </Stack>
      {!!snackbar && (
        <Snackbar
          open
          onClose={() => setSnackbar(null)}
          autoHideDuration={2000}
          anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        >
          <Alert {...snackbar} onClose={() => setSnackbar(null)} />
        </Snackbar>
      )}{" "}
    </MapaContext.Provider>
  );
}
